import { CreditCard } from 'lucide-react';
import { useI18n, type MessageKey } from '../../i18n';
import { Button } from '../../components/Button';
import { errorMessage } from '../../components/Feedback';
import { useToast } from '../../components/Toast';
import { usePayNow } from './hooks';

/** "Nu betalen" (P0-11): hosted iDEAL payment for the open first payment or a failed invoice; renews the mandate. */
export function PayNowButton({ label = 'billing.payNow', variant = 'primary', size = 'md' }: { label?: MessageKey; variant?: 'primary' | 'secondary'; size?: 'sm' | 'md' | 'lg' }) {
  const { t } = useI18n();
  const toast = useToast();
  const pay = usePayNow();
  return (
    <Button
      variant={variant}
      size={size}
      loading={pay.isPending}
      icon={<CreditCard size={16} aria-hidden="true" />}
      onClick={async () => {
        try {
          const r = await pay.mutateAsync();
          if (!r.checkoutUrl) toast.show({ message: t('billing.paid'), tone: 'success' });
        } catch (e) {
          toast.show({ message: errorMessage(e, t), tone: 'error' });
        }
      }}
    >
      {t(label)}
    </Button>
  );
}
